// angular
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../core/auth.service';
import { AppService } from '../../app.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { KlenicoMeService } from '../me.service';

@Component({
    selector: 'me-landing-page-header',
    templateUrl: './landing-page-header.component.html',
    styleUrls: ['./landing-page-header.component.scss'],
})

export class MeLandingPageHeaderComponent implements OnInit, OnDestroy {
    subLanguage: Subscription;
    subFolder: Subscription;
    data: any;
    clinicData : any;
    isFixed = false;
    isMobile = false;
    toggleNav = false;
    url = 'lp/header';
    loading = false;

    constructor(
        public appService: AppService,
        public authService: AuthService,
        public meService : KlenicoMeService,
        public router: Router,
        public translate: TranslateService
    ) {
       
    }

    ngOnInit() {
        this.isMobile = this.appService.isMobile;
        this.clinicData = JSON.parse(this.appService.getMeClinicConfig());
        this.getContent();
        this.subLanguage = this.translate.onLangChange.subscribe(value => {
            this.getContent();
        });

        this.subFolder = this.appService.meClinicFolderChanged.subscribe(value => {
            this.clinicData = JSON.parse(this.appService.getMeClinicConfig());
            if (value != '') {
                this.getContent();
            }
        });
    }

    ngOnDestroy(){
        this.subLanguage.unsubscribe();
        this.subFolder.unsubscribe();
    }

    getContent() {
        this.data = [];
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'] ?? [];
            // Need this to force ui reload new content
            this.loading = false;
        });
    }

    navigateLogin(){
        this.router.navigate(['me/login']);
        this.meService.isLandingPage = false;
        this.toggleNav = !this.toggleNav;
    }

    @HostListener('window:scroll', ['$event']) // for window scroll events
    onScroll(event) {
        const scrollTop = window.scrollY;
        if (scrollTop >= 50) {
            this.isFixed = true;
        } else {
            this.isFixed = false;
        }
    }
}
